<template>
  <div class="bg-blue-900 px-4 pt-4 lg:px-12 lg:pt-12 overflow-hidden">
    <div class="max-w-7xl mx-auto">
      <div class="flex space-x-6 lg:space-x-8">
        <div class="w-64">
          <div class="relative w-full aspect-ratio-16/9">
            <img
              v-if="project.cover"
              :src="project.cover"
              class="absolute w-full h-full inset-0 rounded-t shadow-lg object-cover"
            />
            <div v-else class="bg-blue-800 absolute w-full h-full inset-0 rounded-t shadow-lg" />
          </div>
        </div>
        <div class="flex-1">
          <div class="flex justify-between items-start">
            <div class="space-y-4">
              <div>
                <h3 class="text-xl text-white font-medium">
                  {{ project.name }}
                </h3>
                <div v-if="$isAdminOrSuperAdmin && projectOwner" class="text-blue-200 text-sm">
                  <span class="text-blue-400">project owner:</span> {{ projectOwner.fullName }}
                </div>
              </div>
              <ProjectStatusManager
                v-if="$membershipHasPermissionTo('edit projects')"
                :project-id="project.uuid"
                :status="project.status"
              />
              <BaseBadge v-else silver>
                <span class="uppercase">{{ project.status }}</span>
              </BaseBadge>
            </div>
            <BaseButton
              v-if="$membershipHasPermissionTo('edit projects')"
              tag="router-link"
              :to="{
                name: 'accounts.projects.project.settings',
                params: {
                  accountId,
                  projectId: project.uuid,
                },
              }"
              primary
              class="ml-auto md:ml-4"
            >
              Settings
            </BaseButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectStatusManager from './ProjectStatusManager.vue';

export default {
  components: { ProjectStatusManager },
  name: 'AccountProjectHeader',

  props: {
    project: {
      type: Object,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
  },

  computed: {
    projectOwner() {
      if (!this.project.owner) return undefined;

      return this.$store.state.entities.users.byId[this.project.owner];
    },
  },
};
</script>
